import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

import styles from "./JobDetails.module.css";
import { DateTime } from "luxon";
import { motion } from "framer-motion";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaPhoneAlt,
  FaEnvelope
} from "react-icons/fa";

const JobDetails = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);



useEffect(() => {
  (async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/${id}`);
      setJob(res.data);
    } catch (err) {
      console.error("Error fetching job details", err);
    } finally {
      setLoading(false);
    }
  })();
}, [id]);





  if (loading) return <p className={styles.loading}>Loading...</p>;
  if (!job) return <p className={styles.notFound}>Job not found.</p>;

  return (
    <div className={styles.jobDetailsPage}>
      
      {/* Back Button */}
      <Link to="/jobs" className={styles.backButton}>← Back to Jobs</Link>

      {/* Job Title */}
      <motion.div
        className={styles.titleCard}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1>{job.jobHeading || job.title}</h1>
      </motion.div>

      {/* Company / Location / Date */}
      <motion.div
        className={styles.infoCardRow}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {job.company && (
          <div className={styles.infoCard}>
            <FaBuilding style={{ color: "#0077cc" }} /> {job.company}
          </div>
        )}
        <div className={styles.infoCard}>
          <FaMapMarkerAlt style={{ color: "#28a745" }} /> {job.location || "N/A"}
        </div>
        <div className={styles.infoCard}>
          <FaCalendarAlt style={{ color: "#ff9800" }} />{" "}
          {DateTime.fromISO(job.createdAt)
            .setZone("Asia/Kolkata")
            .toFormat("dd LLL yyyy")}
        </div>
      </motion.div>

      {/* Job Details */}
      <div className={styles.sectionHeader}>📄 Job Details</div>
      <motion.div
        className={styles.detailsCard}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
{Array.isArray(job.jobDetails)
  ? job.jobDetails.map((para, index) => (
      <p
        key={index}
        dangerouslySetInnerHTML={{
          __html: para.replace(
            /((https?:\/\/|www\.)[^\s]+)/g,
            (match) => {
              const url = match.startsWith("http") ? match : `https://${match}`;
              return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#0077cc;">${match}</a>`;
            }
          )
        }}
      />
    ))
  : (
      <p
        dangerouslySetInnerHTML={{
          __html: job.jobDetails.replace(
            /((https?:\/\/|www\.)[^\s]+)/g,
            (match) => {
              const url = match.startsWith("http") ? match : `https://${match}`;
              return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#0077cc;">${match}</a>`;
            }
          )
        }}
      />
    )}


      </motion.div>

      {/* Contact / Email */}
      {(job.contact || job.email) && (
        <motion.div
          className={styles.infoCardRow}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {job.contact && (
            <div className={styles.infoCard}>
              <FaPhoneAlt style={{ color: "#28a745" }} />
              <a href={`tel:${job.contact}`} className={styles.cardLink}>
                {job.contact}
              </a>
            </div>
          )}
          {job.email && (
            <div className={styles.infoCard}>
              <FaEnvelope style={{ color: "#d63384" }} />
              <a href={`mailto:${job.email}`} className={styles.cardLink}>
                {job.email}
              </a>
            </div>
          )}
        </motion.div>
      )}

      {/* Poster */}
      {job.imageUrl && (
        <motion.div
          className={styles.posterWrapper}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <img
            src={job.imageUrl.replace("/upload/", "/upload/w_800,h_500,c_fill/")}
            alt="Job Poster"
            className={styles.posterImage}
          />
       <a
  href={job.imageUrl}
  target="_blank"
  rel="noopener noreferrer"
  className={styles.downloadButton}
>
  👁 View Full Image
</a>

        </motion.div>
      )}
{/* 📄 PDF Document Card */}
{job.pdfUrl && (
  <div className={styles.pdfCard}>
    <h3>📄 Official Job Notification / Recruitment PDF</h3>
    <div className={styles.pdfButtons}>
      <a
        href={job.pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.pdfViewBtn}
      >
        📄 View PDF
      </a>
    
    </div>
  </div>
)}


      {/* Disclaimer */}
      <p className={styles.jobDisclaimer}>
        <strong>Disclaimer:</strong> Please verify all details before applying.{" "}
        <Link to="/disclaimer">Read full disclaimer</Link>
      </p>
    </div>
  );
};

export default JobDetails;
